import { features } from '@/mocks/homeMangaData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">本站特色</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">为漫画爱好者打造的一站式免费漫画在线阅读平台</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((item, i) => (
            <div key={i} className="bg-background-100 rounded-xl p-5 md:p-6 group hover:bg-background-200/70 transition-colors">
              <div className="w-12 h-12 flex items-center justify-center bg-primary-100 text-primary-600 rounded-xl mb-4 text-2xl">
                <i className={item.icon}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}